import React, {useRef} from "react";
import PDAbout from "./PDAbout";
import PDOnboarding from "./PDOnboarding";

export default function PurpleDoorWarning({activeTab,setActiveTab, t, userRole, currentTheme, isNew}) {
  const pdRef = useRef(null);
  return (
    <div className="flex flex-col mt-4 p-2">

      <div className="w-full flex justify-center p-4">
        <div className="w-full max-w-2xl bg-yellow-900/20 border border-purple-500 text-purple-200 rounded-2xl p-6 shadow-lg">

          <div className="text-xl font-bold">
            🚧 PurpleDoor Access Pending
          </div>

          <div className="mt-3 text-xs">
            Your account is not onboarded for PurpleDoor (A platform made to be own BOS - Behavioral Operating System)
          </div>

          <div className="mt-2 bg-black/20 rounded-xl p-2">
           <div className="mt-2 bg-black/20 rounded-xl p-3">
              <div className="font-semibold text-purple-300 mb-3">
                🌟 What You'll Unlock Inside PurpleDoor
              </div>

              <div className="grid grid-cols-2 gap-2 text-xs">
                <div className="bg-black/20 rounded-lg p-2 text-gray-200">
                  🟣 <strong>PurpleDoor</strong><br />
                  Your personal transformation journey
                </div>

                <div className="bg-black/20 rounded-lg p-2 text-gray-200">
                  🌍 <strong>LifeReplays</strong><br />
                  Your daily emotion tracker
                </div>

                <div className="bg-black/20 rounded-lg p-2 text-gray-200">
                  🔥 <strong>Streaks</strong><br />
                  Track & get rewards for consistency and celebrate progress
                </div>

                <div className="bg-black/20 rounded-lg p-2 text-gray-200">
                  🛍️ <strong>FindItLocal</strong><br />
                  Most exciting hyperlocal shopkeeper and buyer engagement
                </div>

                <div className="bg-black/20 rounded-lg p-2 text-gray-200">
                  👤 <strong>GenZ Digital Boutique / Digital Partnership / Digital Franchise</strong><br />
                  An ecosystem to create earnings / employment / jobs and make progress in life by Working FRom Home
                </div>

                <div className="bg-black/20 rounded-lg p-2 text-gray-200">
                  🧠 <strong>Signals</strong><br />
                  AI-powered insights, habits and performance indicators
                </div>

                <div className="bg-black/20 rounded-lg p-2 text-gray-200">
                  📚 <strong>Body of Knowledge</strong><br />
                  Learn, grow and access curated wisdom
                </div>

                <div className="bg-black/20 rounded-lg p-2 text-gray-200">
                  💰 <strong>PocketMoney</strong><br />
                  Rewards, opportunities and value creation
                </div>

                <div className="bg-black/20 rounded-lg p-2 text-gray-200">
                  🏆 <strong>Leaderboard</strong><br />
                  Recognition, achievements and rankings
                </div>
              </div>

              <div className="mt-3 text-[10px] text-gray-300 italic">
                PurpleDoor is being designed as a human transformation ecosystem for
                individuals, families, students, MSMEs, institutions, enterprises,
                communities and governments worldwide.
              </div>
            </div>
          </div>

          <div className="flex flex-row gap-2">
            <button
              onClick={() => {
                setActiveTab("Onboarding");
                setTimeout(() => {
                  pdRef.current?.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                  });
                }, 100);
              }}
              className="mt-6 px-2 py-1 bg-teal-600 text-white rounded-md text-xs"
            >
              Start Onboarding
            </button>
          </div>
        </div>
      </div>

      <div ref={pdRef}>
        <PDOnboarding
          t={t}
          role={userRole}
          currentTheme={currentTheme}
          isNew={isNew}
        />
      </div>
      {/* <button
        onClick={onClose}
        className="px-2 py-1 bg-red-600 text-white rounded-md text-xs"
      >
        Close
      </button> */}
    </div>
  );
}